var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrinidadAndTobago(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66269 2.23093C7.23032 2.97024 5.88575 3.93931 4.685 5.14006C3.48419 6.34087 2.51513 7.68543 1.77588 9.11781L12.0638 20.3896L23.3356 30.6776C24.7681 29.9382 26.1126 28.9692 27.3134 27.7685C28.5142 26.5677 29.4832 25.2231 30.2225 23.7907L19.9346 12.5189L8.66269 2.23093Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3145 27.7686C27.9857 27.0974 28.5843 26.3813 29.1113 25.6301L6.82478 3.34344C6.07359 3.87038 5.3574 4.46901 4.68622 5.14019C4.01503 5.81138 3.4164 6.52757 2.8894 7.27882L25.176 29.5653C25.9271 29.0384 26.6433 28.4398 27.3145 27.7686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68575 27.7681C9.73368 32.816 17.3147 33.785 23.3364 30.6772L1.77668 9.11739C-1.33113 15.139 -0.361942 22.7202 4.68575 27.7681V27.7681Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.314 5.13972C22.266 0.091846 14.685 -0.877154 8.66333 2.23053L30.223 23.7904C33.3309 17.7688 32.3619 10.1876 27.314 5.13972V5.13972Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.454102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrinidadAndTobago);
export default __webpack_public_path__ + "static/media/trinidad-and-tobago.eb3897cc.svg";
export { ForwardRef as ReactComponent };